import env from "../../environment"
import { create as ipfsHttpClient } from "ipfs-http-client";

export const sendFileToIPFS = async (file) => {

    if (file) {
        try {

            const authorization = "Basic " + btoa(env.PROJECT_ID + ":" + env.PROJECT_SECRET);
            const ipfs = ipfsHttpClient({
                url: env.INFURA,
                headers: {
                    authorization
                }
            })
            const result = await ipfs.add(file);
            console.log("result", result)
            // console.log("ImgHash", res)
            const ImgHash = `${env.IPFS_PATH}/${result.path}`;

            return ImgHash;

        } catch (error) {
            console.log("Error sending File to IPFS: ")
            console.log(error)
        }
    }
}